import client from 'providers/fetchClient'

export const createCoupon = data => client.post('/coupons', data)

export const getCoupons = () => client.get('/coupons')

export const getFilteredCupouns = params => client.get('/coupons', { params })

export const getCouponByID = id => client.get(`/coupons/${id}`)
export const updateCoupon = (id, data) => client.put(`/coupons/${id}`, data)
export const deleteCoupon = id => client.delete(`/coupons/${id}`)

export const getCouponDetail = id => client.get(`/discount-coupons/${id}`)

export const editCoupon = (id, data) => client.patch(`/discount-coupons/${id}`, data)

export const registerNewDiscountCoupon = data => client.post('/discount-coupons', data)

export const getCouponsList = async ({ sortBy, pagination, search, ...filters }) => {
  const params = { search, ...filters }

  if (sortBy && sortBy.length) {
    params.ordering = sortBy.map(({ id, desc }) => (desc ? `-${id}` : id)).join(',')
  }

  if (pagination) {
    params.page = pagination.currentPage
    params.limit = pagination.pageSize
  }

  const { data } = await client.get('/discount-coupons', {
    params: {
      ...params,
    },
  })

  return {
    coupons: data?.data,
    pagination: {
      pageSize: data.limit,
      currentPage: data.page,
      totalPages: data.total_pages,
      totalRecords: data.total,
    },
  }
}

export const exportClientsCSV = id => client.post(`/discount-coupons/${id}/export-csv`)

export const getCouponUseHistory = async (couponId, { sortBy, pagination, search, ...filters }) => {
  const params = { search, ...filters }

  if (sortBy && sortBy.length) {
    params.ordering = sortBy.map(({ id, desc }) => (desc ? `-${id}` : id)).join(',')
  }

  if (pagination) {
    params.page = pagination.currentPage
    params.limit = pagination.pageSize
  }

  const { data } = await client.get(`/discount-coupons/${couponId}/used-history`, {
    params: {
      ...params,
    },
  })

  return {
    subscribers: data?.data,
    pagination: {
      pageSize: data.limit,
      currentPage: data.page,
      totalPages: data.total_pages,
      totalRecords: data.total,
    },
  }
}

export const deleteDiscountCoupon = id => client.delete(`/discount-coupons/${id}`)
